/**
 * Dependencies.
 */
import AddressSearchModel from '@/api/address/search.model';
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

/**
 * Service.
 */
class AddressSearchService extends BaseService<AddressSearchModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      AddressSearchModel,
      AddressSearchModel.name,
      applicationConstant.apiCustomerPublicUrl
    );
  }
}

/**
 * Export `addressSearchService`.
 */
export const addressSearchService = new AddressSearchService();
